import { track } from './track'

export const installTrack = (app) => {
  app.directive('track', track)
}
